$(document).ready(() => {
  const classActive = 'hpe-modal--active';

  function closeVideo($modal) {
    $modal.find('video').each(function () {
      this.pause();
      this.currentTime = 0;
    });
  }

  const $modalButtons = $('[data-modal]');
  $modalButtons.click(function () {
    const modalSelector = $(this).data('modal');
    const $modal = $(modalSelector);
    $modal.addClass(classActive);
  });

  const $modalClose = $('.hpe-modal__close');
  $modalClose.click(function () {
    const $modal = $modalClose.closest('.hpe-modal');
    $modal.removeClass(classActive);
    closeVideo($modal);
  });

  const $modal = $('.hpe-modal');
  $modal.click(function () {
    $(this).removeClass(classActive);
    closeVideo($(this));
  });

  const $modalWrapper = $('.hpe-modal__content');
  $modalWrapper.click(function (event) {
    event.stopPropagation();
  });
});



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/modal.js